import { render, staticRenderFns } from "./InformShippingCompany.vue?vue&type=template&id=f477b3d4&"
import script from "./InformShippingCompany.vue?vue&type=script&lang=js&"
export * from "./InformShippingCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports